import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../../reducers/userInfoReducer';
import { selectDefaultCreationEnvironment } from '../environmentsReducer';
import { useChangeEnvironment } from '../../../../hooks/useChangeEnvironment';
import { DefaultEnvContext } from './DefaultEnvContext';

export const GlobalEnvProvider = ({ children }: { children: React.ReactNode }) => {
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId) ?? undefined;
  const crmOrg = useSelector(selectDefaultCreationEnvironment);
  const { changeEnvironment } = useChangeEnvironment();

  return (
    <DefaultEnvContext.Provider value={{ crmOrgId, crmOrg, changeEnvironment }}>
      {children}
    </DefaultEnvContext.Provider>
  );
};
